export default "__VITE_ASSET__feda5072__"